// components/ui/SummaryChip.tsx

type SummaryChipProps = {
    label: string;
    value: number;
    type?: "paid" | "refund" | "remaining" | "neutral";
    highlight?: boolean;
};

export function SummaryChip({
    label,
    value,
    type,
    highlight = false,
}: SummaryChipProps) {
    // Auto detect type if not provided
    const resolvedType =
        type ??
        (value < 0
            ? "refund"
            : label.toLowerCase().includes("remain")
                ? "remaining"
                : "paid");

    const colors = {
        paid: "text-emerald-600 bg-emerald-50 border-emerald-200",
        refund: "text-rose-600 bg-rose-50 border-rose-200",
        remaining: "text-blue-600 bg-blue-50 border-blue-200",
        neutral: "text-slate-600 bg-slate-50 border-slate-200",
    };

    const cls = [
        "flex items-center gap-1 px-2 py-1 rounded-md border text-[11px] font-medium min-w-0 w-full",
        highlight ? "shadow-sm" : "",
        colors[resolvedType] ?? colors.neutral,
    ].join(" ");

    const format = (n: number) =>
        n.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

    return (
        <div className={cls}>
            <span className="truncate min-w-0">{label}:</span>
            <span className="font-semibold whitespace-nowrap shrink-0">${format(value)}</span>
        </div>
    );
}